<p-toast />
<p-tabView>
  <p-tabPanel header="Datos Nave Viaje">
    <br>
    <form [formGroup]="group_edicion" class="a-w1">
      <div class="a-w1-column">
        <div class="a-w1-row">
          <div class="a-w2">
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <input inputId="on_label" [ngClass]="{'readonly': true}" class="w-full md:w-56" type="text"
                    formControlName="codigonvia" pInputText placeholder="‎" />
                  <label for="on_label">Código</label>
                </p-floatlabel>
              </div>
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [ngClass]="{'readonly': true}" [options]="ListaTodosEstado"
                    placeholder="‎" optionLabel="nombre" formControlName="Estado" optionValue="codigo" appendTo="body"
                    [filter]="true" [showClear]="true" styleClass="w-full md:w-56">
                  </p-select>
                  <label for="on_label">Estado</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
          <div class="a-w2">
            <p-floatlabel class="w-full md:w-56" variant="on">
              <p-select inputId="on_label" [readonly]="readonlyTransportista" [options]="ListaTodosTransportista"
                placeholder="‎" optionLabel="nombre" formControlName="Transportista" optionValue="codigo"
                appendTo="body" [filter]="true" [showClear]="!readonlyTransportista" styleClass="w-full md:w-56">
              </p-select>
              <label for="on_label">Transportista</label>
            </p-floatlabel>
            <small *ngIf="group_edicion.get('Transportista')?.invalid && group_edicion.get('Transportista')?.touched
              && group_edicion.get('Transportista')?.markAsTouched" class="p-error">Seleccione un Transportista</small>
          </div>
        </div>
        <div class="a-w1-row">
          <div class="a-w2">
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [readonly]="readonlyVia" [options]="ListaTodosVia" placeholder="‎"
                    optionLabel="nombre" formControlName="Via" optionValue="codigo" appendTo="body" [filter]="true"
                    [showClear]="!readonlyVia" styleClass="w-full md:w-56" (onChange)="onViaChange($event, 'EVE')"
                    [ngClass]="{'p-disabled': readonlyVia}">
                  </p-select>
                  <label for="on_label">Via</label>
                </p-floatlabel>
                <small *ngIf="group_edicion.get('Via')?.invalid && group_edicion.get('Via')?.touched"
                  class="p-error">Seleccione una Vía</small>
              </div>
              <div class="a-example-full-width-alterno-content-2">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select inputId="on_label" [readonly]="esEditar" [options]="ListaTodosRegimen" placeholder="‎"
                    optionLabel="nombre" formControlName="Regimen" optionValue="codigo" appendTo="body" [filter]="true"
                    [showClear]="!esEditar" styleClass="w-full md:w-56" (onChange)="onRegimenChange($event, 'EVE')"
                    [ngClass]="{'p-disabled': esEditar}">
                  </p-select>
                  <label for="on_label">Régimen</label>
                </p-floatlabel>
                <small *ngIf="group_edicion.get('Regimen')?.invalid && group_edicion.get('Regimen')?.touched"
                  class="p-error">Seleccione un Régimen</small>
              </div>
            </div>
          </div>
          <div class="a-w2">
            <p-floatlabel class="w-full md:w-56" variant="on">
              <p-select inputId="on_label" [readonly]="readonlyNave" [options]="ListaTodosNave" placeholder="‎"
                optionLabel="nave_nombre" formControlName="NaveViaje" optionValue="nave_codigo" appendTo="body"
                virtualScroll="true" [filter]="true" [showClear]="true" styleClass="w-full md:w-56" (onChange)="onNaveChange($event, 'EVE')">
              </p-select>
              <label for="on_label">Nave</label>
            </p-floatlabel>
            <!-- <small
            *ngIf="!group_edicion.get('NaveViaje')?.value && group_edicion.get('NaveViaje')?.touched && (esMaritimo || esAereo)"
            class="p-error">Seleccione una Nave Viaje</small> -->
          </div>
        </div>
        <div *ngIf="esInicial" class="a-w1-row">
          <div class="a-w1">
            <p-floatlabel class="w-full md:w-56" variant="on">
              <p-select inputId="on_label" [readonly]="readonlyPuerto" [options]="ListaPuertosFiltrados" placeholder="‎"
                optionLabel="nombre" formControlName="codpuerto" optionValue="codigo" appendTo="body" [filter]="true"
                [showClear]="!readonlyPuerto" styleClass="w-full md:w-56" [virtualScroll]="true"
                (onChange)="validateFeederFinal($event,'EVE')">
              </p-select>
              <label for="on_label">{{lblPuerto}}</label>
            </p-floatlabel>
          </div>
          <div class="a-w1">
            <p-floatlabel class="w-full md:w-56" variant="on">
              <input inputId="on_label" [readonly]="readonlyNroViaje" class="w-full md:w-56" type="text"
                formControlName="NVIA_NroViaje" pInputText placeholder="‎" />
              <label for="on_label">{{lblNroViaje}}</label>
            </p-floatlabel>
            <small
              *ngIf="!group_edicion.get('NVIA_NroViaje')?.value && group_edicion.get('NVIA_NroViaje')?.touched && esMaritimo"
              class="p-error">Ingrese un {{lblNroViaje}}</small>
            <small
              *ngIf="!group_edicion.get('NVIA_NroViaje')?.value && group_edicion.get('NVIA_NroViaje')?.touched && esAereo"
              class="p-error">Ingrese un {{lblNroViaje}}</small>
          </div>
        </div>
        <div class="a-w1-row">
          <div class="a-w1">
            <div class="a-w1-row">
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esInicial">
                  <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyEta }" formControlName="feceta"
                    appendTo="body" [showIcon]="!readonlyEta" [showWeek]="false" styleClass="w-full md:w-56"
                    dateFormat="dd/mm/yy" [showOnFocus]="false" inputId="buttondisplay">
                  </p-datepicker>
                  <label for="on_label">{{lblFecETDETA}}</label>
                </p-floatlabel>
                <small
                  *ngIf=" !group_edicion.get('feceta')?.value && group_edicion.get('feceta')?.touched && esCerrado && esRGM002Expo && esVIA002"
                  class="p-error">Ingrese un {{lblFecETDETA}}</small>
                <small
                  *ngIf="group_edicion.get('feceta')?.value && group_edicion.get('feceta')?.touched && esCerrado && esRGM002Expo && esVIA002 &&valfec002"
                  class="p-error">{{lblFecETDETA}} debe ser menor a {{lblFecCierreDirecc}}</small>
              </div>
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-datepicker inputId="on_label" formControlName="etaactualizado" appendTo="body" [showIcon]="true"
                    [showWeek]="false" styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showOnFocus]="false"
                    inputId="buttondisplay">
                  </p-datepicker>
                  <label for="on_label">ETA Actualizado</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
          <div class="a-w1">
            <div class="a-w1-row">
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esInicial">
                  <p-datepicker inputId="on_label" [ngClass]="{readonly: readonlyLlegada}" formControlName="Llegada"
                    appendTo="body" [showIcon]="!readonlyLlegada" [showWeek]="false" styleClass="w-full md:w-56"
                    (onSelect)="onFechaLlegadaSelect($event)" dateFormat="dd/mm/yy" [hourFormat]="'24'"
                    [showTime]="mostrarHoraLlegada" [showOnFocus]="false" inputId="buttondisplay">
                  </p-datepicker>
                  <label for="on_label">{{lblFecLLegaImpo_Z_Expo}}</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('Llegada')?.value && group_edicion.get('Llegada')?.touched && esCerrado"
                  class="p-error">Ingrese una {{lblFecLLegaImpo_Z_Expo}}</small>
                <small
                  *ngIf="group_edicion.get('Llegada')?.value && group_edicion.get('Llegada')?.touched && esCerrado && esRGM002Expo && valfec001"
                  class="p-error">{{lblFecLLegaImpo_Z_Expo}} debe ser menor o igual a {{lblFecCierreDirecc}}</small>
                <small
                  *ngIf="group_edicion.get('Llegada')?.value && group_edicion.get('Llegada')?.touched && esCerrado && esRGM002Expo && valfec003"
                  class="p-error">{{lblFecLLegaImpo_Z_Expo}} debe ser menor o igual que {{lblFecETDETA}}</small>
                <small *ngIf="group_edicion.get('Llegada')?.value && group_edicion.get('Llegada')?.touched &&
                esCerrado && esRGM001Impo && valfec006" class="p-error"> {{lblFecLLegaImpo_Z_Expo}} debe ser mayor o
                  igual que
                  {{lblFecETDETA}}</small>
              </div>
              <div class="a-w1">
                <div class="a-checkbox ">
                  <p-checkbox formControlName="viajefeeder" [binary]="true" inputId="binary" appendTo="body">
                  </p-checkbox>
                  <label class="ml-2"> Viaje Feeder</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="esInicial" class="a-w1-row">
          <div class="a-w1">
            <div class="a-w1-row">
              <div class="a-w1">
                <!-- <div class="a-w1-row"> -->
                <!-- <div class="a-example-full-width-alterno-content-0_5"> -->
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-datepicker inputId="on_label" [ngClass]="{readonly: readonlyCierre}"
                    formControlName="CierreDireccionamiento" appendTo="body" [showWeek]="false"
                    styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showOnFocus]="false"
                    [showIcon]="!readonlyCierre">
                  </p-datepicker>
                  <label for="on_label">{{lblFecCierreDirecc}}</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('CierreDireccionamiento')?.value && group_edicion.get('CierreDireccionamiento')?.touched && esCerrado"
                  class="p-error">Ingrese una {{lblFecCierreDirecc}}</small>
                <small *ngIf=" group_edicion.get('CierreDireccionamiento')?.value && group_edicion.get('CierreDireccionamiento')?.touched &&
                    esCerrado && esRGM001Impo && noesVIA002 && valfec008" class="p-error">{{lblFecCierreDirecc}} debe
                  ser
                  menor a las fechas (ETA, Descarga, Llegada)</small>
                <!-- </div> -->
                <!-- <div class="a-example-full-width-alterno-content-4">
                    <p-datepicker formControlName="cierredireccionamientohoras" appendTo="body" class="p-inputtext-sm"
                      [timeOnly]="true" [showSeconds]="false" [showClear]="true" [showOnFocus]="false"
                      inputId="buttondisplay" (onInput)="formatTime($event)">
                    </p-datepicker>
                  </div> -->
                <!-- </div> -->
              </div>
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esImportacion">
                  <p-datepicker inputId="on_label" [ngClass]="{readonly: readonlyDescarga}"
                    formControlName="FechaDescarga" appendTo="body" [showIcon]="!readonlyDescarga" [showWeek]="false"
                    styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showOnFocus]="false" inputId="buttondisplay">
                  </p-datepicker>
                  <label for="on_label">Fecha de Descarga</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('FechaDescarga')?.value && group_edicion.get('FechaDescarga')?.touched && esRGM001Impo"
                  class="p-error">Ingrese una Fecha</small>
                <small
                  *ngIf=" group_edicion.get('FechaDescarga')?.value && group_edicion.get('FechaDescarga')?.touched && esCerrado && esRGM001Impo && valfec007"
                  class="p-error">Fec. Descarga debe ser mayor como máx. en 10 días a la Fec. Llegada</small>
                <div *ngIf="esExportacion" class="a-w1-row">
                  <div class="a-example-full-width-alterno-content-0_5">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                      <p-datepicker inputId="on_label" [ngClass]="{readonly: readonlyDescarga}"
                        formControlName="Fecha_CutOff" appendTo="body" [showWeek]="false" styleClass="w-full md:w-56"
                        dateFormat="dd/mm/yy" [showOnFocus]="false" [showIcon]="!readonlyDescarga">
                      </p-datepicker>
                      <label for="on_label">Fecha CutOff</label>
                    </p-floatlabel>
                    <small *ngIf="!group_edicion.get('Fecha_CutOff')?.value && group_edicion.get('Fecha_CutOff')?.touched
                  && esCerrado && esRGM002Expo && esVIA002" class="p-error">Ingrese una Fec. CutOff</small>
                    <small
                      *ngIf="group_edicion.get('Fecha_CutOff')?.value && group_edicion.get('Fecha_CutOff')?.touched && esCerrado && esRGM002Expo && esVIA002 &&valfec004"
                      class="p-error">Fec. CutOff debe ser menor a {{lblFecETDETA}}</small>
                  </div>
                  <div class="a-example-full-width-alterno-content-4">
                    <p-datepicker formControlName="Horas_Fecha_CutOff" appendTo="body" styleClass="w-full md:w-56"
                      [timeOnly]="true" [showSeconds]="false" [showOnFocus]="false" inputId="buttondisplay"
                      (onInput)="formatTime($event)">
                    </p-datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="a-w1">
            <div class="a-w1-row">
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <input inputId="on_label" [readonly]="readonlyManifiesto" class="w-full md:w-56" type="text"
                    formControlName="Manifiesto" pInputText placeholder="‎ " (onInput)="formatCustomInput($event)" />
                  <label for="on_label">Manifiesto</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('Manifiesto')?.value && group_edicion.get('Manifiesto')?.touched && esCerrado "
                  class="p-error">Ingrese un Manifiesto</small>
              </div>
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esImportacion">
                  <input inputId="on_label" [readonly]="readonlyDesconsolidado" class="w-full md:w-56" type="text"
                    formControlName="desconsolidado" pInputText placeholder="‎" (onInput)="formatCustomInput($event)" />
                  <label for="on_label">Desconsolidado</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('desconsolidado')?.value && group_edicion.get('desconsolidado')?.touched && esCerrado && esRGM001Impo && noesVIA002"
                  class="p-error">Ingrese el Desconsolidado</small>
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esExportacion">
                  <p-datepicker inputId="on_label" [ngClass]="{readonly: readonlyDesconsolidado}"
                    formControlName="FechaRecogoDocumentos" appendTo="body" [showWeek]="false"
                    styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showClear]="!readonlyDesconsolidado"
                    [showOnFocus]="false" [showIcon]="!readonlyDesconsolidado">
                  </p-datepicker>
                  <label for="on_label">Fecha Recoger Doc.</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('FechaRecogoDocumentos')?.value && group_edicion.get('FechaRecogoDocumentos')?.touched && esCerrado && esRGM002Expo && esVIA002"
                  class="p-error">Ingrese una Fec. Recoger Docs.</small>
                <small *ngIf="group_edicion.get('FechaRecogoDocumentos')?.value && group_edicion.get('FechaRecogoDocumentos')?.touched &&
                esCerrado && esRGM002Expo && esVIA002 && valfec005" class="p-error">Fec. Recogo Docs debe ser mayor a
                  {{lblFecLLegaImpo_Z_Expo}}</small>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="esInicial" class="a-w1-row">
          <div class="a-w1">
            <div class="a-w1-row">
              <div class="a-w1">
                <!-- <div class="a-w1-row"> -->
                <!-- <div class="a-4"> -->
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-datepicker inputId="on_label" formControlName="plazovistobueno" appendTo="body" [showWeek]="false"
                    styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [showOnFocus]="false" [showIcon]="true">
                  </p-datepicker>
                  <label for="on_label">Plazo V. Bueno</label>
                </p-floatlabel>
                <!-- </div> -->
                <!-- <div class="a-example-full-width-alterno-content-4">
                    <p-datepicker formControlName="plazovistobuenohoras" appendTo="body" class="p-inputtext-sm"
                      [timeOnly]="true" [showSeconds]="false" [showClear]="true" [showOnFocus]="false"
                      inputId="buttondisplay" (onInput)="formatTime($event)">
                    </p-datepicker>
                  </div> -->
                <!-- </div> -->
              </div>
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-datepicker inputId="on_label" [ngClass]="{readonly: readonlyZarpe}" formControlName="fechazarpe"
                    appendTo="body" [showIcon]="!readonlyZarpe" [showWeek]="false" styleClass="w-full md:w-56"
                    dateFormat="dd/mm/yy">
                  </p-datepicker>
                  <label for="on_label">{{lblFecLLegaExpo_Z_Impo}}</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
          <div class="a-w1">
            <p-floatlabel class="w-full md:w-56" variant="on">
              <p-select inputId="on_label" [readonly]="readonlyTerminalPortuario" [options]="ListaTerminalPortuario"
                optionLabel="nombre" formControlName="TerminalPortuario" optionValue="codigo" appendTo="body"
                [filter]="true" [showClear]="!readonlyTerminalPortuario" styleClass="w-full md:w-56" placeholder="‎ ">
              </p-select>
              <label for="on_label">Terminal Portuario</label>
            </p-floatlabel>
            <small *ngIf="group_edicion.get('TerminalPortuario')?.touched && esCerrado" class="p-error">Seleccione un
              Terminal Portuario</small>
          </div>
        </div>
        <div *ngIf="esInicial" class="a-w1-row">
          <div class="a-w1">
            <div class="a-w1-row">
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esImportacion">
                  <p-select inputId="on_label" [readonly]="readonlyAgente" [options]="ListaAgentePortuario"
                    optionLabel="nombre" formControlName="agente" optionValue="codigo" appendTo="body" [filter]="true"
                    [showClear]="!readonlyAgente" styleClass="w-full md:w-56" placeholder="‎ ">
                  </p-select>
                  <label for="on_label">Agente Portuario VoBo</label>
                </p-floatlabel>
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esExportacion">
                  <p-select inputId="on_label" [readonly]="readonlyAgente" [options]="ListaAgentePortuario"
                    optionLabel="nombre" formControlName="AgentePortuario" optionValue="codigo" appendTo="body"
                    [filter]="true" [showClear]="!readonlyAgente" styleClass="w-full md:w-56" placeholder="‎ ">
                  </p-select>
                  <label for="on_label">Agente Portuario</label>
                </p-floatlabel>
                <small
                  *ngIf="!group_edicion.get('AgentePortuario')?.value && group_edicion.get('AgentePortuario')?.touched && esCerrado && esRGM002Expo && esVIA002"
                  class="p-error">Seleccione un Agente Portuario</small>
                <small
                  *ngIf="!group_edicion.get('AgentePortuario')?.value && group_edicion.get('AgentePortuario')?.touched && esCerrado && esRGM001Impo && noesVIA002"
                  class="p-error">Seleccione un Agente Portuario</small>
              </div>
              <div class="a-w1">
                <p-floatlabel class="w-full md:w-56" variant="on" *ngIf="esImportacion">
                  <p-select inputId="on_label" [readonly]="readonlyAgente2" [options]="ListaAgentePortuario"
                    optionLabel="nombre" formControlName="agente2" optionValue="codigo" appendTo="body" [filter]="true"
                    [showClear]="!readonlyAgente2" styleClass="w-full md:w-56" placeholder="‎ ">
                  </p-select>
                  <label for="on_label">Agente Portuario VoBo 2</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
        </div>
        <div class="a-w1-row">
          <div class="a-w2">
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-w2">
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-52">
                    <i class="pi pi-user mr-2"></i>
                    <label>Usr. Creación:</label>
                  </div>
                  <div class="w-40">
                    <label> <strong>{{this.row.usrcreacion}}</strong></label>
                  </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-52">
                    <i class="pi pi-user mr-2"></i>
                    <label>Usr. Pre-Factura:</label>
                  </div>
                  <div class="w-40">
                    <label><strong>{{usrprefactura}}</strong></label>
                  </div>
                </div>
              </div>
              <div class="a-w2">
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-52">
                    <i class="pi pi-calendar mr-2"></i>
                    <label>Fec. Creación: </label>
                  </div>
                  <div class="w-40">
                    <label><strong>{{this.row.feccreacion}}</strong></label>
                  </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-52">
                    <i class="pi pi-calendar mr-2"></i>
                    <label>Fec. Pre-Factura:</label>
                  </div>
                  <div class="w-40">
                    <label><strong>{{fecprefactura}}</strong></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="a-w2">
            <div class="a-example-full-width-alterno-content-row">
              <div class="a-w2">
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-66">
                    <i class="pi pi-user mr-2"></i>
                    <label>Usr. Emi. Statement:</label>
                  </div>
                  <div class="w-40">
                    <label><strong>{{usremitestatemnt}}</strong></label>
                  </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-66">
                    <i class="pi pi-user mr-2"></i>
                    <label>Usr. Cierre Nave:</label>
                  </div>
                  <div class="w-40">
                    <label><strong>{{usrcerrarnave}}</strong></label>
                  </div>
                </div>
              </div>
              <div class="a-w2">
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-66">
                    <i class="pi pi-calendar mr-2"></i>
                    <label>Fec. Emi. Statement: </label>
                  </div>
                  <div class="w-40">
                    <label><strong> {{fecemitestatemnt}}</strong></label>
                  </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                  <div class="w-66">
                    <i class="pi pi-calendar mr-2"></i>
                    <label>Fec. Cierre Nave:</label>
                  </div>
                  <div class="w-40">
                    <label><strong>{{feccerrarnave}}</strong></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="a-example-full-width-alterno-content-row">
          <p-button icon="pi pi-save" (onClick)="transaccionNaveViaje('U')" label="Guardar"
            [disabled]="btn_guardar"></p-button>
          <p-button icon="pi pi-times" (onClick)="salir()" label="Salir"></p-button>
          <p-splitButton icon="pi pi-file-o" label=" Archivo's" [model]="archivositems" [disabled]="!btn_archivos" />
          <p-splitButton icon="pi pi-envelope" label=" Email's" [model]="emailitems" [disabled]="!btn_emails" />
        </div>
      </div>
    </form>
  </p-tabPanel>
  <p-tabPanel header="Detalle Nave Viaje">
    <br>
    <app-datatable [dataTable]="datatableDetNaveViaje" [metadataTable]="metadataDetNaveViaje" [key]="'key'"
      [filterGlobal]="true" title="Detalle Nave Viaje">
    </app-datatable>
    <br>
    <app-datatable [dataTable]="datatableAuditoriaDetNaveViaje" [metadataTable]="metadataAuditoriaDetNaveViaje"
      [key]="'key'" [filterGlobal]="true" [customButtons]="customDetAuditoria" title="Auditoría Detalle Nave Viaje">
    </app-datatable>
  </p-tabPanel>
  <p-tabPanel header="Auditoría Nave Viaje">
    <br>
    <app-datatable [dataTable]="datatableAuditoriaNaveViaje" [metadataTable]="metadataAuditoriaNaveViaje" [key]="'key'"
      [filterGlobal]="true" [customButtons]="customAuditoria">
    </app-datatable>
  </p-tabPanel>
</p-tabView>